<script>
import SavePresetButton from './SavePresetButton.vue';
import ResetButton from './ResetButton.vue';

export default {
  name: 'PredictorFooter',
  components: {
    SavePresetButton,
    ResetButton,
  },
  props: {
    resetPredictor: {
      type: Function,
      required: true,
    },
  },
};
</script>

<template>
  <div class="predictor-footer">
    <div class="predictor-footer__primary">
      <div class="predictor-footer__image-wrap">
        <img
          class="predictor-footer__image"
          src="https://puntcdn.com/predictor/Predictor+Graphic2x.png"
        >
      </div>
      <div class="predictor-footer__text">
        <p class="predictor-footer__text-title">How it works</p>
        <p>
          The Predictor analyses the winning chance of every horse in the race based on a set of key form factors, such as strike rate, record at the track and trip, etc. (there’s 18 of them so we’ll spare you the full breakdown). The horse that is found to have the strongest winning chance will be assigned 100% and the weakest 0%; the percentage of the remaining horses will reflect where they sit within that spectrum.
          <br >
          <br >To learn more about the predictor please read our
          <a
            href="https://www.punters.com.au/faq/using-the-race-predictor/"
            class="predictor-footer__faq"
          >Predictor FAQ.</a>
        </p>
      </div>
    </div>
  </div>
</template>
